import {Injectable} from "@angular/core";
import {ReCaptchaV3Service} from "ng-recaptcha";
import {Observable} from "rxjs";

export enum RecaptchaAction {
    LOGIN = "login",
    CONTACT = "contact",
    SIGN_UP_EMPLOYEE = "sign_up_employee",
    NEW_DELIVERY_POINT = "new_delivery_point",
    SIGN_IN = "register",
    VALIDATE_COUPON = "validate_coupon",
    CREATE_LIST = "create_list",
    CHANGE_EMAIL = "change_email",

}

@Injectable()
export class RecaptchaService {
    constructor(
        private recaptchaV3Service: ReCaptchaV3Service,
    ) {}

    /**
     * Executes the recaptcha action and returns the token
     * @param action
     */
    getToken(action: RecaptchaAction): Observable<string> {
        return this.recaptchaV3Service.execute(action);
    }
}
